/**
 * Signup campaign pixel IDs – events are sent only to these, not to other fbq/gtag on the page.
 */
const META_PIXEL_ID = '1175826780972141';
const GOOGLE_ADS_ID = 'AW-16857382404';

/**
 * Fires when user has filled the signup form and moves to the code entry step (Lead / generate_lead).
 * Uses trackSingle (Meta) and send_to (gtag) so only the signup campaign pixels receive the event.
 * @param {Object} urlParams - URL query params as object (e.g. UTM, source, etc.)
 */
export function fireSignUpFormSubmittedPixels(urlParams) {
    if(typeof window === 'undefined') return;
    const params = urlParams || {};

    if(typeof window.fbq === 'function') {
        window.fbq('trackSingle', META_PIXEL_ID, 'Lead', params);
    }
    if(typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', {...params, send_to: GOOGLE_ADS_ID});
    }
}

/**
 * Fires when user has completed verification and registration (CompleteRegistration / sign_up).
 * Uses trackSingle (Meta) and send_to (gtag) so only the signup campaign pixels receive the event.
 * @param {Object} urlParams - URL query params as object (e.g. UTM, source, etc.)
 */
export function fireSignUpConversionPixels(urlParams) {
    if(typeof window === 'undefined') return;
    const params = urlParams || {};

    if(typeof window.fbq === 'function') {
        window.fbq('trackSingle', META_PIXEL_ID, 'CompleteRegistration', params);
    }
    if(typeof window.gtag === 'function') {
        window.gtag('event', 'sign_up', {...params, send_to: GOOGLE_ADS_ID});
    }
}
